import React from 'react';
import { useParams } from 'react-router-dom';
import { usePermissions } from 'react-admin';

import {
  General,
  ReportingPerson,
  Parties,
  Goods,
} from './paths';

import Generate from './Generate';

import { FormNavigation, Child } from '../layout/formNavigation';
import actions, { Actions } from '../../constants/actions';
import hasAccess from '../../utilities/hasAccess';

const SAR = () => {
  const { caseId } = useParams();
  const { permissions } = usePermissions<Actions[]>();
  return (
    <FormNavigation exitTo={`/cases/${caseId}`}>
      <Child path="general" label="General">
        <General />
      </Child>
      <Child path="reporting-person" label="Reporting person">
        <ReportingPerson />
      </Child>
      <Child path="parties" label="Parties">
        <Parties />
      </Child>
      {hasAccess(permissions, actions.CAR_LIST) && (
        <Child path="goods" label="Goods">
          <Goods />
        </Child>
      )}
      <Child path="generate" label="Generate report">
        <Generate reportCode="SAR" />
      </Child>
    </FormNavigation>
  );
};

export default SAR;
